import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getstaffDesignation,
  addstaffDesignation,
  editstaffDesignation,
  deletestaffDesignation,
  markDefaultDesignation,
} from "actions/index";
import { Modal, ModalBody } from "reactstrap";

/*components*/
import _isLoading from "hoc/isLoading";
import AddEditRole from "./components/addeditRole";
import Toast from "components/Toast";
import { Accordion } from "react-accessible-accordion";
import { withTranslation } from "react-i18next";
import constants from "./../../constants";
import Page from "components/Page";
import AccordionCommonComponent from "./components/AccordionCommonComponent";
import RoleList from "./components/RoleList";

class StaffRoles extends Component {
  state = {
    addModal: false,
    roleDetail: null,
    deleteModal: false,
    deletRoleId: null,
    isToastView: false,
    catType: null,
  };

  componentDidMount() {
    const officeId =
      this.props.profile && this.props.profile.officeId
        ? this.props.profile.officeId
        : 0;
    this.props.getstaffDesignation(officeId);

    if (
      this.props.profile &&
      (this.props.profile.profileSetupStep === "packageExpired" ||
        this.props.profile.profileSetupStep === "subscriptionTerminated")
    ) {
      this.props.history.push("/");
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.isRoleAdded !== this.props.isRoleAdded ||
      prevProps.isRoleAddedError !== this.props.isRoleAddedError
    ) {
      window.scrollTo(0, 0);
      this.setState({ isToastView: true });
      setTimeout(() => {
        this.setState({ isToastView: false });
      }, 3000);
    }
  }

  modalOpen = (id) => {
    this.setState({ addModal: true, roleDetail: null });
    if (
      this.props.profile &&
      this.props.profile.role.systemRole === constants.systemRoles.superAdmin
    ) {
      this.setState({ catType: id });
    }
  };

  modalClose = () => {
    this.setState({ addModal: false, roleDetail: null });

    if (
      this.props.profile &&
      this.props.profile.roleId === constants.systemRoles.superAdmin
    ) {
      this.setState({ catType: null });
    }
  };

  handleEdit = (row) => {
    this.setState({ addModal: true, roleDetail: row });
  };
  handleDeleteModal = (row) => {
    this.setState({ deleteModal: true, deletRoleId: row.id });
  };
  handleDeleteModalClose = () => {
    this.setState({ deleteModal: false });
  };
  handleDeleteRole = () => {
    const payload = {
      id: this.state.deletRoleId,
      officeId: this.props.profile.officeId ? this.props.profile.officeId : 0,
    };
    if (
      this.props.profile &&
      this.props.profile.role.systemRole === constants.systemRoles.accountOwner
    ) {
      payload.ownerId = this.props.profile.id;
    }
    this.props.deletestaffDesignation(payload);
    this.setState({ deleteModal: false });
  };

  deleteConfirm = () => (
    <Modal
      isOpen={this.state.deleteModal}
      className="modal-dialog-centered  delete-role-modal"
      modalClassName="custom-modal"
      toggle={this.handleDeleteModalClose}
    >
      <span className="close-btn" onClick={this.handleDeleteModalClose}>
        <img src={require("assets/images/cross.svg").default} alt="close" />
      </span>
      <ModalBody>
        <div className="delete-content mt-4">
          <p>{this.props.t("staffRoleDeleteConfirmationText")}</p>
          <button
            className="button button-round button-shadow button-min-100 margin-right-2x"
            title={this.props.t("ok")}
            onClick={this.handleDeleteRole}
          >
            {this.props.t("ok")}
          </button>
          <button
            className="button button-round button-border button-dark"
            title={this.props.t("cancel")}
            onClick={this.handleDeleteModalClose}
          >
            {this.props.t("cancel")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );

  handleMarkDefault = (row) => {
    const payload = {
      id: row.id,
      officeId: this.props.profile.officeId ? this.props.profile.officeId : 0,
    };

    this.props.markDefaultDesignation({ ...payload });
  };

  toastHide = () => {
    this.setState({ isToastView: false });
  };

  render() {
    const { staffDesignation, statusMessage, isRoleAddedError, t } = this.props;
    const { addModal, deleteModal, isToastView, catType } = this.state;

    const isSuperAdmin =
      this.props.profile &&
      this.props.profile.role.systemRole === constants.systemRoles.superAdmin;

    const designationList =
      staffDesignation && staffDesignation.designations_list;

    // Filter roles by different criteria
    const getRolesByFilter = (filterFn) => {
      return designationList?.filter(filterFn) || [];
    };

    const staffDesignationData = isSuperAdmin
      ? getRolesByFilter((item) => item.masterRoleId === 1)
      : getRolesByFilter((item) => item.isSuperAdmin);

    const mangeRoleData = isSuperAdmin
      ? getRolesByFilter((item) => item.masterRoleId === 2)
      : getRolesByFilter((item) => !item.isSuperAdmin);

    const physicanRoleData = getRolesByFilter(
      (item) => item.masterRoleId === 3
    );
    const labImageRoleData = getRolesByFilter(
      (item) => item.masterRoleId === 4
    );
    const goBack = () => this.props.history.goBack();
    return (
      <Page title={t("accountOwner.staffRoles")} onBack={goBack}>
        <div className="staff-roles-block">
          {isToastView && statusMessage && (
            <Toast
              message={statusMessage}
              handleClose={this.toastHide}
              errorToast={
                isRoleAddedError ||
                statusMessage ===
                  "The role is already assigned to staff members and cannot be deleted"
                  ? true
                  : false
              }
            />
          )}

          <Accordion preExpanded={["a"]}>
            <AccordionCommonComponent
              title={
                isSuperAdmin
                  ? t("accountOwner.dentalRoles")
                  : t("accountOwner.staffRoles")
              }
              modalOpen={() => this.modalOpen(1)}
              enabledAddButton={isSuperAdmin}
              parentClass="staff-roles-list"
              uuid="a"
              t={t}
            >
              <RoleList
                roles={staffDesignationData}
                onEdit={this.handleEdit}
                onDelete={this.handleDeleteModal}
                onMarkDefault={this.handleMarkDefault}
                t={t}
                isSuperAdmin={isSuperAdmin}
                showMarkDefault={!isSuperAdmin}
              />
            </AccordionCommonComponent>
            <AccordionCommonComponent
              title={
                isSuperAdmin
                  ? t("accountOwner.medicalRoles")
                  : t("accountOwner.manageRoles")
              }
              modalOpen={() => this.modalOpen(2)}
              enabledAddButton={true}
              parentClass="manage-staff-role-list"
              childClass="mange-role-list"
              uuid="b"
              t={t}
            >
              <RoleList
                roles={mangeRoleData}
                onEdit={this.handleEdit}
                onDelete={this.handleDeleteModal}
                onMarkDefault={this.handleMarkDefault}
                t={t}
                isSuperAdmin={isSuperAdmin}
                showMarkDefault={!isSuperAdmin}
              />
            </AccordionCommonComponent>

            {isSuperAdmin && (
              <>
                <AccordionCommonComponent
                  title={t("accountOwner.pharmacistRoles")}
                  modalOpen={() => this.modalOpen(3)}
                  enabledAddButton={true}
                  parentClass="physican-role-list"
                  childClass="physican-data-list"
                  uuid="c"
                  t={t}
                >
                  <RoleList
                    roles={physicanRoleData}
                    onEdit={this.handleEdit}
                    onDelete={this.handleDeleteModal}
                    onMarkDefault={this.handleMarkDefault}
                    t={t}
                    showMarkDefault={false}
                    showEditDelete={true}
                    isSuperAdmin={isSuperAdmin}
                  />
                </AccordionCommonComponent>
                <AccordionCommonComponent
                  title={t("accountOwner.labImagingAndMedicalRoles")}
                  modalOpen={() => this.modalOpen(4)}
                  enabledAddButton={true}
                  parentClass="physican-role-list"
                  childClass="physican-data-list"
                  uuid="d"
                  t={t}
                >
                  <RoleList
                    roles={labImageRoleData}
                    onEdit={this.handleEdit}
                    onDelete={this.handleDeleteModal}
                    onMarkDefault={this.handleMarkDefault}
                    t={t}
                    isSuperAdmin={isSuperAdmin}
                    showMarkDefault={false}
                  />
                </AccordionCommonComponent>
              </>
            )}
          </Accordion>

          {deleteModal && this.deleteConfirm()}
          {addModal && (
            <AddEditRole
              RoleType={this.props.profile.role.systemRole}
              CatType={catType}
              DataRow={this.state.roleDetail}
              show={addModal}
              closeModal={this.modalClose}
              AddRole={this.props.addstaffDesignation}
              EditRole={this.props.editstaffDesignation}
              OfficeID={this.props.profile.officeId}
              profile={this.props.profile}
            />
          )}
        </div>
      </Page>
    );
  }
}

const mapStateToProps = ({
  userProfile: { profile },
  staff: {
    staffDesignation,
    isLoading,
    statusMessage,
    isRoleAddedError,
    isRoleAdded,
  },
  errors: { isError },
}) => ({
  staffDesignation,
  isLoading,
  isError,
  profile,
  statusMessage,
  isRoleAddedError,
  isRoleAdded,
});

export default connect(mapStateToProps, {
  getstaffDesignation,
  addstaffDesignation,
  editstaffDesignation,
  deletestaffDesignation,
  markDefaultDesignation,
})(_isLoading(withTranslation()(StaffRoles)));
